import { logDebug, type LogTarget, noop } from '@amazon/vinyl-util'
import { debug } from '@/core/debug'

declare global {
    var pageStartedAt: number
}

/**
 * Instruments with performance logging.
 *
 * @param name
 * @param inner
 */
export function instrument<F extends (...args: any[]) => Promise<any>>(name: string, inner: F): F {
    if (!debug) return inner
    const target: LogTarget = {
        logPrefix: name,
    }
    return ((...args) => {
        logDebug(target, 'start', elapsedStr())
        const start = Date.now()
        const result = inner(...args)
        result
            .then(() => {
                const end = Date.now()
                logDebug(target, 'end', elapsedStr(), formatMs(end - start))
            })
            .catch(noop)
        return result
    }) as F
}

export function formatMs(ms: number): string {
    return Math.round(ms) + 'ms'
}

export function elapsed(): number {
    return Date.now() - global.pageStartedAt
}

export function elapsedStr(): string {
    return formatMs(elapsed())
}
